import { Table, type TableRow } from '~/components/ui/table';
import type { BuyListQuery } from '~/graphql/graphql';
import { BuyListLocation } from './BuyListLocation';
import {
  buyerCell,
  buyListNoteTestId,
  expectedShipDateCell,
  useBuyListColumns,
  vehicleCell,
} from './buyListSummaryCells';

type BuyListSummaryTableProps = {
  buyList: BuyListQuery['buyList'];
  showBuyerColumn: boolean;
  testId: string;
};

export function BuyListSummaryTable({
  buyList,
  showBuyerColumn,
  testId,
}: Readonly<BuyListSummaryTableProps>) {
  const columns = useBuyListColumns({ showBuyerColumn, isSortable: false });

  const row: TableRow = {
    id: { value: buyList.id },
    products: { value: buyList.items.length },
    location: {
      value: <BuyListLocation buyList={buyList} testId={testId} />,
    },
    vehicle: vehicleCell(buyList, testId),
    expectedShipDate: expectedShipDateCell(buyList),
    note: {
      value: buyList.note ? (
        <span
          className="block whitespace-pre-line"
          data-testid={buyListNoteTestId(testId, buyList.id)}
        >
          {buyList.note}
        </span>
      ) : (
        ''
      ),
    },
    ...(showBuyerColumn ? { buyer: buyerCell(buyList) } : {}),
  };

  return (
    <div className="bg-neut-bg-alt overflow-hidden" data-testid={testId}>
      <Table minWidth={40} rows={[row]} columns={columns} />
    </div>
  );
}
